import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import { suggestCategory } from '../../lib/api';

/**
 * Shows a "Suggested: X" chip when the receipt has no category yet.
 * Fires POST /api/receipts/suggest-category on mount / when vendor changes.
 */
export default function CategorySuggestionChip({ data, colors, onAccept }) {
  const [sug, setSug] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Only suggest if no category currently set
    if (data.category) { setSug(null); return; }
    const vendor = data.vendor?.value || '';
    if (!vendor.trim()) { setSug(null); return; }
    setLoading(true);
    suggestCategory(vendor, {
      total: data.total?.value ?? undefined,
      content: data.notes || undefined,
    })
      .then((r) => setSug(r?.suggested_category ? r : null))
      .catch(() => setSug(null))
      .finally(() => setLoading(false));
  }, [data.category, data.vendor, data.total, data.notes]);

  if (data.category || loading || !sug || !sug.suggested_category) return null;

  return (
    <button
      data-testid="category-suggestion-chip"
      onClick={() => onAccept(sug.suggested_category)}
      className="w-full mb-2 rounded-lg border px-3 py-2 flex items-center gap-2 text-left transition-opacity hover:opacity-80"
      style={{ backgroundColor: colors.accentSoft, borderColor: colors.accent }}
    >
      <Sparkles size={14} style={{ color: colors.accent }} />
      <div className="flex-1 min-w-0">
        <p className="text-xs font-bold" style={{ color: colors.accent }}>
          Suggested: {sug.suggested_category}{' '}
          <span className="text-[10px] font-normal" style={{ color: colors.textMuted }}>
            · {sug.source}{sug.confidence ? ` · ${Math.round(sug.confidence * 100)}%` : ''}
          </span>
        </p>
        {sug.reason ? (
          <p className="text-[11px] mt-0.5 truncate" style={{ color: colors.textMuted }}>{sug.reason}</p>
        ) : null}
      </div>
      <span className="text-[10px] font-bold uppercase" style={{ color: colors.accent }}>
        Accept
      </span>
    </button>
  );
}
